import styled from '../../config/theme'

const Wrapper = styled.div<{ state: 'start' | 'middle' | 'end', padding: boolean, buttonOut: boolean }>`
  display: flex;
  position: relative;

  ${props => props.padding && 'padding: 0 50px;'}

  > button {
    position: absolute;
    height: 100%;
    width: 30px;
    &:first-child {
      left: ${props => props.buttonOut ? '-60px' : '0'};
      // background: linear-gradient(90deg, white 60%, ${props => props.theme.color.transparent});
      border: none;

      ${props => props.state === 'start' && 'display: none;'}
    }
    &:last-child {
      right: ${props => props.buttonOut ? '-60px' : '0'};
      // background: linear-gradient(-90deg, white 60%, ${props => props.theme.color.transparent});
      border: none;

      ${props => props.state === 'end' && 'display: none;'}
    }
  }

  @media screen and (max-width: 1024px) {
    > button {
      &:first-child {
        left: ${props => props.buttonOut ? '-5px' : '0'};
        // background: linear-gradient(90deg, white 60%, ${props => props.theme.color.transparent});
        border: none;
  
        ${props => props.state === 'start' && 'display: none;'}
      }
      &:last-child {
        right: ${props => props.buttonOut ? '-5px' : '0'};  
      }
    }
  }
`

const Container = styled.div<{ items: number, perPage: number }>`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;

  > * {
    margin: 0 30px;
    width: calc(${props => 100 / props.perPage}% - 60px);
    display: inline-flex;
  }
  @media screen and (max-width: 1024px) {
    > * {
      margin: 0 50px;
      width: calc(${props => 100 / props.perPage}% - 100px);
    }    
  }

`

export { Container, Wrapper, }
